module.exports = __webpack_public_path__ + "static/media/armarios-cubro.e9aea441.png";